module.exports = __webpack_public_path__ + "static/media/skyWhiteWalker.910e6977.jpg";